import React from 'react';
import { Status } from '../../api/Notifications/schema';
import { TitleAndTag } from './commonShell/TitleAndTag';
import { DismissButton } from './commonShell/DismissButton';

interface InformationalNotificationProps {
  externalId: string;
  title: string;
  message: string;
  notificationMetadata: {};
  timestamp?: string;
  dismissable: boolean;
  handleDismiss(id: string): void;
  status?: Status;
}

export const InformationalNotification: React.FC<
  InformationalNotificationProps
> = ({
  externalId,
  title,
  message,
  timestamp,
  notificationMetadata,
  dismissable,
  handleDismiss,
  status,
}: InformationalNotificationProps): React.ReactElement => {
  return (
    <>
      <TitleAndTag
        title={title}
        message={message}
        timestamp={timestamp}
        status={status}
      />
      <span style={{ paddingLeft: '30px' }}>
        <DismissButton
          externalId={externalId}
          dismissable={dismissable}
          handleDismiss={handleDismiss}
          notificationMetadata={notificationMetadata}
        />
      </span>
      <span style={{ paddingTop: '10px' }}></span>
    </>
  );
};
